import React, { useState, useEffect } from 'react';
import { Link, RouteComponentProps } from 'react-router-dom';
import { Button, Row, Col } from 'reactstrap';
import { Translate, translate, ValidatedField, ValidatedForm } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { getEntity, updateEntity, createEntity, reset } from './met-source-beneficiary.reducer';
import { useAppDispatch, useAppSelector } from 'app/config/store';
import { Status } from 'app/shared/model/enumerations/status.model';
import metSourceBeneficiary from 'app/entities/met-source-beneficiary/met-source-beneficiary.reducer';

export const MetSourceBeneficiaryUpdate = (props: RouteComponentProps<{ id: string }>) => {
  const dispatch = useAppDispatch();

  const [isNew] = useState(!props.match.params || !props.match.params.id);

  const metSourceBeneficiaryEntity = useAppSelector(state => state.metSourceBeneficiary.entity);
  const loading = useAppSelector(state => state.metSourceBeneficiary.loading);
  const updating = useAppSelector(state => state.metSourceBeneficiary.updating);
  const updateSuccess = useAppSelector(state => state.metSourceBeneficiary.updateSuccess);
  const statusValues = Object.keys(Status);
  const handleClose = () => {
    props.history.push('/met-source-beneficiary');
  };

  useEffect(() => {
    if (isNew) {
      dispatch(reset());
    } else {
      dispatch(getEntity(props.match.params.id));
    }
  }, []);

  useEffect(() => {
    if (updateSuccess) {
      handleClose();
    }
  }, [updateSuccess]);

  const saveEntity = values => {
    const entity = {
      ...metSourceBeneficiaryEntity,
      ...values,
    };

    if (isNew) {
      dispatch(createEntity(entity));
    } else {
      dispatch(updateEntity(entity));
    }
  };

  const defaultValues = () =>
    isNew
      ? {}
      : {
          status: 'ACTIVE',
          ...metSourceBeneficiaryEntity,
        };

  return (
    <div>
      <Row className="justify-content-center">
        <Col md="8">
          <h2 id="almobadaraMasterDataApp.metSourceBeneficiary.home.createOrEditLabel" data-cy="MetSourceBeneficiaryCreateUpdateHeading">
            <Translate contentKey="almobadaraMasterDataApp.metSourceBeneficiary.home.createOrEditLabel">
              Create or edit a MetSourceBeneficiary
            </Translate>
          </h2>
        </Col>
      </Row>
      <Row className="justify-content-center">
        <Col md="8">
          {loading ? (
            <p>Loading...</p>
          ) : (
            <ValidatedForm defaultValues={defaultValues()} onSubmit={saveEntity}>
              {!isNew ? (
                <ValidatedField
                  name="id"
                  required
                  readOnly
                  id="met-source-beneficiary-id"
                  label={translate('global.field.id')}
                  validate={{ required: true }}
                />
              ) : null}
              <ValidatedField
                label={translate('almobadaraMasterDataApp.metSourceBeneficiary.name')}
                id="met-source-beneficiary-name"
                name="name"
                data-cy="name"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                }}
              />
              <ValidatedField
                label={translate('almobadaraMasterDataApp.metSourceBeneficiary.nameAr')}
                id="met-source-beneficiary-nameAr"
                name="nameAr"
                data-cy="nameAr"
                type="text"
              />
              <ValidatedField
                label={translate('almobadaraMasterDataApp.metSourceBeneficiary.nameEn')}
                id="met-source-beneficiary-nameEn"
                name="nameEn"
                data-cy="nameEn"
                type="text"
              />
              <ValidatedField
                label={translate('almobadaraMasterDataApp.metSourceBeneficiary.status')}
                id="met-source-beneficiary-status"
                name="status"
                data-cy="status"
                type="select"
              >
                {statusValues.map(status => (
                  <option value={status} key={status}>
                    {translate('almobadaraMasterDataApp.Status.' + status)}
                  </option>
                ))}
              </ValidatedField>
              <Button tag={Link} id="cancel-save" data-cy="entityCreateCancelButton" to="/met-source-beneficiary" replace color="info">
                <FontAwesomeIcon icon="arrow-left" />
                &nbsp;
                <span className="d-none d-md-inline">
                  <Translate contentKey="entity.action.back">Back</Translate>
                </span>
              </Button>
              &nbsp;
              <Button color="primary" id="save-entity" data-cy="entityCreateSaveButton" type="submit" disabled={updating}>
                <FontAwesomeIcon icon="save" />
                &nbsp;
                <Translate contentKey="entity.action.save">Save</Translate>
              </Button>
            </ValidatedForm>
          )}
        </Col>
      </Row>
    </div>
  );
};

export default MetSourceBeneficiaryUpdate;
